import React, { useState, useEffect } from "react";

/**
 * トップバナー
 */
const TopBanner: React.FC = () => {
  const [currentDate, setCurrentDate] = useState<string>("");

  // 日付のフォーマット
  const setFormattedDate = () => {
    const now = new Date();
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    const day = now.getDate().toString().padStart(2, "0");
    const weekday = now.toLocaleDateString("ja-JP", { weekday: "short" });
    setCurrentDate(`${month}/${day}(${weekday})`);
  };

  // 日付の更新
  useEffect(() => {
    setFormattedDate();

    const interval = setInterval(() => {
      setFormattedDate();
    }, 1000 * 60);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="sticky top-0 z-10 flex justify-center items-center min-h-8"
      style={{ backgroundColor: "var(--main-bg)" }}
    >
      <div
        className="w-[30%] md:w-[20%] h-6 min-h-6 rounded flex justify-center items-center"
        style={{ backgroundColor: "var(--date-bg)" }}
      >
        <span
          className="text-xs md:text-sm leading-none"
          style={{
            color: "var(--date-text)",
            fontSize: "var(--date-font-size, 13px)",
          }}
        >
          {currentDate}
        </span>
      </div>
    </div>
  );
};

export default TopBanner;
